import { create } from 'zustand';

import type { AuthState } from './authState';
import { authDefault, AuthStatus } from './authState';

interface Store extends AuthState {
  setError: (error: Error) => void;
  resetError: () => void;
  handleError: (error: Error) => void;
  handleAuth: (idToken: string) => void;
  handleLogout: () => void;
  handleLoggingOut: () => void;
  handleGameServerConnected: () => void;
  handleGameServerDisconnected: () => void;
}

export const authStore = create<Store>((set) => ({
  ...authDefault,
  setError: (error: Error): void => set(() => ({ error })),
  resetError: (): void => set(() => ({ error: null })),
  handleError: (error: Error): void =>
    set(() => ({
      error,
    })),
  handleAuth: (idToken: string): void =>
    set(() => ({
      authIdToken: idToken,
      status: AuthStatus.LOGGED_IN_CONNECTING_TO_GAME_SERVER,
      error: null,
    })),
  handleGameServerConnected: (): void =>
    set(() => ({
      status: AuthStatus.LOGGED_IN_CONNECTED_TO_GAME_SERVER,
      error: null,
    })),
  handleGameServerDisconnected: (): void =>
    set(() => ({
      status: AuthStatus.LOGGED_IN_CONNECTING_TO_GAME_SERVER,
    })),
  handleLoggingOut: (): void =>
    set(() => ({
      status: AuthStatus.LOGGING_OUT,
    })),
  handleLogout: (): void =>
    set(() => ({
      authIdToken: null,
      status: AuthStatus.LOGGED_OUT,
      anonymous: false,
      error: null,
    })),
}));
